<div class="admin-content">
  <h2>Usuários</h2>
  <div class="admin-content__actions" routerLink="/admin/pessoas/incluir">
    <cei-button type="button">Adicionar usuário</cei-button>
  </div>

  <cei-scrollable-action-table
    [columns]="columns"
    [carregamento]="carregamentoTabela"
    [pageFetcher]="buscarPagina"
    [pageSize]="10"
    [sortEnabled]="true"
    [selecionavel]="true"
    [chaveLinha]="'id'"
    [autoLoad]="autoLoad"
    [acoesLinha]="acoesLinha"
    (linhaSelecionada)="aoSelecionarLinha($event)"
    (pageLoaded)="aoCarregarPagina($event)"
    (loadError)="aoErroCarregamento($event)"
  ></cei-scrollable-action-table>
</div>
